
<template>
  <div>
    <v-dialog v-model="dialog" scrollable persistent :overlay="false" max-width="800px" transition="dialog-transition">
      <template v-slot:activator="{ on }">
        <v-btn v-on="on" color="primary" v-if='can_operate'>
          <v-icon small left>mdi-calendar</v-icon>
          Feriados
        </v-btn>
      </template>

      <v-card style="border-radius:12px">
        <v-card-title primary-title>
          <div class="headline mb-0">Feriados</div>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="py-3">
          <v-alert type="info" :value="true" v-if="loading_holidays">
            Carregando metas...
            <v-progress-linear color='white' :indeterminate="true"></v-progress-linear>
          </v-alert>
          <v-form ref='holidaysForm' lazy-validation v-if="!loading_holidays">
            <v-row class="pa-2 mb-3" justify="center">
              <div v-for="year in years_filters" :key="year">
                <v-btn class="mx-1" small rounded :color="year_filter == year? 'primary' : 'white'" @click="year_filter = year">{{year}}</v-btn>
              </div>
            </v-row>
            <div v-for="(holiday, idx) in holidays_list_comp" :key="holiday.id + '--' + idx">
              <v-row justify="center" align="center">
                <v-text-field @change="submitHoliday(idx)" v-model="holiday.name" prepend-icon="mdi-search"
                  label="Nome do feriado" class="mx-2" :rules="[rules.required]"></v-text-field>

                <v-dialog ref="dialog" :return-value.sync="holiday.date" width="290px">
                  <template v-slot:activator="{ on }">
                    <v-text-field v-on="on"
                      :value="new Date(holiday.date.substring(0, 10) + 'T12:00:00').toLocaleDateString('pt-BR').substring(0, 10)"
                      label="Data" prepend-icon="mdi-calendar" readonly class="mx-2"></v-text-field>
                  </template>
                  <v-date-picker v-model="holiday.date" color="primary" locale="pt-br" scrollable>
                    <v-spacer></v-spacer>
                    <v-btn text icon color="success"
                      @click="$refs.dialog[idx].save(holiday.date); submitHoliday(idx)"><v-icon>mdi-check</v-icon></v-btn>
                    <v-spacer></v-spacer>
                  </v-date-picker>
                </v-dialog>

                <v-btn text icon color="success" @click="submitNewHoliday(idx)"
                  v-if="!holiday.id"><v-icon>save</v-icon></v-btn>
                <v-btn text icon color="error" @click="removeHoliday(idx)"><v-icon>mdi-delete</v-icon></v-btn>
              </v-row>
            </div>
            <v-btn text color="primary" @click="addHoliday()" rounded><v-icon left>mdi-plus</v-icon>Feriado</v-btn>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="justify-end">
          <v-btn color="primary" @click="dialog = false">Ok</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Api from '@/api/index';

export default {
  name: 'SetupHolidays',
  data() {
    return {
      key: null,
      dialog: false,
      loading_holidays: false,
      adding_holiday: false,
      editing_holiday: false,
      holidays_list: [
      ],
      rules: {
        required: v => !!v || 'Campo é necessário',
      },

      year_filter: new Date().getFullYear(),

    }
  },
  methods: {
    getHolidays() {
      this.loading_holidays = true
      Api.Holiday.index({year: this.year_filter}).then(r => r.data).then(r => {
        r = r.map(h => {
          let { id, name, date } = h
          return {
            id, name, date: date.substring(0, 10)
          }
        })
        this.holidays_list = [...r]
      }).finally(() => {
        this.loading_holidays = false
      })
    },
    addHoliday() {
      this.adding_holiday = true

      let new_holiday = { name: null, date: this.year_filter+ new Date().toISOString().substring(4, 10) }
      this.holidays_list.push({ ...new_holiday })
    },
    removeHoliday(idx) {
      if (this.holidays_list[idx].id) {
        Api.Holiday.delete(this.holidays_list[idx].id).then(r => r.data).then(r => {
          this.holidays_list.splice(idx, 1)
        }).catch((err) => {
          console.log(err);
        }).finally(() => {
          this.editing_holiday = false
        })
      } else {
        this.holidays_list.splice(idx, 1)
      }
    },
    submitNewHoliday(idx) {
      this.editing_holiday = true
      let { id, name, date } = this.holidays_list[idx]
      if (!id) {
        if (this.$refs.holidaysForm.validate()) {

          let new_holiday = {
            id,
            name,
            date
          }

          Api.Holiday.create(new_holiday).then(r => r.data).then(r => {
            let { id, name, date } = r
            r = {
              id, name, date: date.substring(0, 10)
            }
            this.holidays_list.splice(idx, 1, { ...r })
          }).catch((err) => {
            console.log(err);
          }).finally(() => {
            this.editing_holiday = false
          })
        }
      }
    },
    submitHoliday(idx) {
      this.editing_holiday = true
      let { id, name, date } = this.holidays_list[idx]

      if (id) {
        let up_holiday = {
          id,
          name,
          date
        }

        Api.Holiday.update(up_holiday).then(r => r.data).then(r => {
          this.holidays_list.splice(idx, 1, { ...r })
        }).catch((err) => {
          console.log(err);
        }).finally(() => {
          this.editing_holiday = false
        })
      }
    },
    submitHolidays() {
      if (this.$refs.holidaysForm.validate()) {
        let c = confirm('Deseja enviar feriados?')
        if (c) {
          this.dialog = false
          this.$emit('done')
        }
      }
    },
  },
  computed: {
    years_filters(){
      let year = (new Date()).getFullYear()
      let years = []
      for (let i = 3; i > 0; i--) {
        years.push(year - i)
      }
      years.push(year)
      for (let i = 1; i <= 3; i++) {
        years.push(year + i)
      }
      return years.sort()
    },
    holidays_list_comp(){
      if (this.holidays_list.length){
        return this.holidays_list.filter(h=> h.date.includes(this.year_filter+'-'))
      }
      return []
    },
    can_operate() {
      if (this.has_roles(['Director', 'Manager', 'SalesExecutive'])) {
        return true
      } else {
        return false
      }
    },
  },
  watch: {
    year_filter(nv,ov) {
      if (nv){
        this.getHolidays()
      }
    },
    dialog(nv, ov) {
      if (nv) {
        this.getHolidays()
      } else if (nv == false) {
        this.holidays_list = []
      }
    }
  },
}
</script>